<app-sidebar>
    <div>
        <router-outlet #outlet="outlet"></router-outlet>
    </div>
    <app-loader [enabled]="enabled$ | async"></app-loader>
</app-sidebar>
